'use client';

import { telegramBotUrl } from '@repo/config';
import { useTranslations } from 'next-intl';
import { BsApple, BsGooglePlay, BsTelegram } from 'react-icons/bs';
import { Link } from './link';
import { Subheading } from './text';

interface IStoreButtonProps {
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  eyebrow: string;
  label: string;
}

function StoreButton({ href, icon: Icon, eyebrow, label }: IStoreButtonProps): React.JSX.Element {
  return (
    <Link
      href={href}
      className="inline-flex items-center gap-3 rounded-2xl bg-gray-950 px-5 py-3 text-white shadow-md transition data-hover:bg-gray-800"
    >
      <Icon className="size-6" />
      <span className="flex flex-col items-start leading-tight">
        <span className="text-[10px] font-medium uppercase tracking-wider text-gray-300">
          {eyebrow}
        </span>
        <span className="text-sm font-semibold">{label}</span>
      </span>
    </Link>
  );
}

export function FooterCallToAction(): React.JSX.Element {
  const t = useTranslations('footer.cta');
  return (
    <div className="relative pt-20 pb-16 text-center sm:py-24">
      <hgroup>
        <Subheading>{t('eyebrow')}</Subheading>
        <p className="mt-6 text-xl font-medium tracking-tight text-foreground sm:text-3xl md:text-4xl lg:text-5xl">
          {t('headlineTop')}
          <br />
          {t('headlineBottom')}
        </p>
      </hgroup>
      <p className="mx-auto mt-6 max-w-xs text-sm/6 text-muted-foreground">{t('subline')}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <StoreButton
          href="/ios"
          icon={BsApple}
          eyebrow={t('appStoreEyebrow')}
          label={t('appStoreLabel')}
        />
        <StoreButton
          href="/android"
          icon={BsGooglePlay}
          eyebrow={t('googlePlayEyebrow')}
          label={t('googlePlayLabel')}
        />
        <StoreButton
          href={telegramBotUrl}
          icon={BsTelegram}
          eyebrow={t('telegramEyebrow')}
          label={t('telegramLabel')}
        />
      </div>
    </div>
  );
}
